module.exports = __webpack_public_path__ + "static/media/5x7no1.34affd72.jpg";